import { Product } from 'common/components/product-card/types';

export enum CompareActions {
  ADD = 'add',
  DELETE = 'delete',
  DELETE_GROUP = 'deleteGroup',
  LOAD_DATA = 'loadData',
  LOAD = 'load',
  REQUEST = 'request',
}

export type ProductStub = {
  productId: string;
};

export type UnifiedCompareGroup = {
  name: string;
  groupId: string;
  productsData: Record<string, Product | ProductStub>;
  isDataLoaded: boolean;
  isSyncedWithServer: boolean;
};

export type UnifiedCompareState = Record<string, UnifiedCompareGroup>;

export type CompareListRequest = {
  customerId: string;
  compareList: {
    name: string;
    groupId: string;
    products: string[];
  };
};

export type CompareListStatus = {
  statusCode: number;
  type: string;
  message: string;
};

export type UserActionState = {
  action: CompareActions | null;
  productId: string;
  familyId: string;
  groupId: string;
  groupName?: string;
  productIds?: string[];
};

export type ProductErrorState = {
  error: Response | Error | null;
  productId: string;
  groupId: string;
  currentState?: UnifiedCompareState;
};

export type ProductCompareData = { content: Product[] };

export type CompareListsFromAPI = {
  name: string | null;
  groupId: string | null;
  products: string[];
}[];

export type ApiError = {
  response?: { status?: number };
  status?: number;
  message?: string;
};

export type LoadingState = 'none' | 'loading' | 'loaded';
